import React, { useMemo } from 'react';
import { Splide, SplideSlide } from '@splidejs/react-splide';
import {
    carouselFullwidth,
    carouselStandard,
} from '~/utilities/carousel-helpers';
import Product from '~/components/elements/products/Product';
import '@splidejs/react-splide/css';

export const ProductGroupWithCarousel = ({ products, type, fullwidth }) => {
    const isCarousel = useMemo(() => {
        return fullwidth ? products.length >= 7 : products.length >= 5;
    }, [products.length, fullwidth]);

    const sliderProps = useMemo(
        () => (fullwidth ? carouselFullwidth : carouselStandard),
        [fullwidth]
    );

    const infinite = useMemo(() => isCarousel, [isCarousel]);

    const splideOptions = useMemo(() => {
        const base = {
            type: 'loop',
            perPage: sliderProps.slidesToShow || 1,
            perMove: sliderProps.slidesToScroll || 1,
            focus: sliderProps.centerMode ? 'center' : 0,
            autoplay: sliderProps.autoplay || false,
            interval: sliderProps.autoplaySpeed || 3000,
            speed: sliderProps.speed || 500,
            easing: sliderProps.ease || 'linear',
            arrows: sliderProps.arrows !== false,
            dots: sliderProps.dots !== false,
            infinite: infinite,
            gap: sliderProps.variableWidth ? '0px' : '0px',
            breakpoints: sliderProps.responsive ? Object.fromEntries(
                Object.entries(sliderProps.responsive).map(([breakpoint, settings]) => [
                    breakpoint,
                    {
                        perPage: settings.slidesToShow || 1,
                        perMove: settings.slidesToScroll || 1,
                        arrows: settings.arrows !== false,
                        dots: settings.dots !== false,
                    }
                ])
            ) : {},
        };

        if (sliderProps.centerMode) {
            base.focus = 'center';
        }

        if (sliderProps.vertical) {
            base.direction = 'vertical';
            base.height = sliderProps.verticalHeight || '400px';
        }

        return base;
    }, [sliderProps, infinite]);

    if (isCarousel) {
        return (
            <Splide
                options={splideOptions}
                className="ps-carousel outside"
            >
                {products.map((item) => (
                    <SplideSlide className="ps-carousel-item" key={item.id}>
                        <Product product={item} />
                    </SplideSlide>
                ))}
            </Splide>
        );
    } else {
        return (
            <div className="product-grid">
                {products.map((item) => (
                    <div className="product-grid-item" key={item.id}>
                        <Product product={item} />
                    </div>
                ))}
            </div>
        );
    }
};